export const OCCUPANCIES = 'occupanciesEdit';
export const AGENCY_SELLING_PRICE = 'sellingPrice';
export const AGENCY_TAX = 'taxes';
export const MARGIN_ADJUSTMENT = 'marAdj';
export const TOTAL_MARGIN = 'totalMar';
export const HOTEL_EBB = 'ebbHotel';
export const TOUR_EBB = 'ebbTour';
export const ACV_EBB = 'ebbAcv';
export const PF_DISCOUNT = 'pfDis';
export const LAND_COST = 'landCost';
export const FL_COST = 'flCost';
export const COST_ADJUSTMENT = 'costAdj';
export const TOTAL_COST = 'totalCost';
export const HOTEL_COST_ADJ = 'hotelCostAdj';
export const ARD_BASE_FARE = 'ardBaseFare';
export const ARD_TAXES = 'ardTaxes';
export const NET_MARGIN = 'netMargin';
export const FL_COST_OFFSET = 'flCostOffset';
export const FL_COST_ADJUSTMENT = 'flCostAdjustment';
export const SUPPLIER_COST = 'supplierCost';
export const SUPPLIER_TAX = 'supplierTax';
export const SUPPLIER_SUPPLEMENT = 'supplierSupplement';
export const SUPPLIER_COST_CAD = 'supplierCostCAD';
export const HOTEL_COST_CAD = 'hotelCostCAD';

export const SUFFIX_AGENCY_SELLING_PRICE = '';
export const SUFFIX_TAX = 'Tax';
export const SUFFIX_PUBLIC = 'Gbp';
export const SUFFIX_GROUPB = 'Vp';
export const SUFFIX_VACV = 'Rate';
export const SUFFIX_NCCF = 'NCCF';
export const SUFFIX_CHARTER = 'Charter';
export const SUFFIX_TOTAL_SELLING = 'total';

export const SELLING_TAXES = 'sellingTaxes';
export const SUB_TOTAL_SELLING_PRICE = 'subTotalSellingPrice';
export const TOTAL_SELLING_PRICE = 'totalSellingPrice';
export const HOTEL_COST_LOCAL = 'hotelCostLocal';
export const COST_CAD_SUMMARY = 'hotelCostCad';
export const COST_ADJUSTMENT_SUMMARY = 'costAdjustment';
export const TRANSFER_COST = 'transferCost';
export const FLIGHT_COST_CAD = 'flightCostCad';
export const FLIGHT_TAXES = 'flightTaxes';
export const SUB_TOTAL_COST = 'subTotalCost';
export const NUMBER_OF_ADULT_AND_CHILD = 'numOfAdultsAndChild';
export const SELLING_PRICE_SUMMARY = 'sellingPriceSummary';
export const NCCF = 'nccf';
export const COST_SUMMARY = 'costSummary';
export const BASE_COST = 'baseCost';
export const BASE_TAXES = 'baseTax';
